import { createSelector } from '@reduxjs/toolkit';
import { ScheduledBatchState } from 'ducks/scheduled-batch/slices';
import { RootState } from 'store';

const scheduledBatchSlice = (state: RootState) => state.scheduled_batch;

export const selectScheduledBatch = createSelector([scheduledBatchSlice], (state): ScheduledBatchState => state);
export const selectScheduledBatchId = createSelector(
  [scheduledBatchSlice],
  (state): ScheduledBatchState['batch_definition_id'] => state.batch_definition_id,
);
